import { defineMessages } from 'react-intl';

export default defineMessages({
    trueLabel: {
        id: 'BooleanField.trueLabel',
        defaultMessage: 'Yes',
        description: 'Label for the "true" option.'
    },
    falseLabel: {
        id: 'BooleanField.falseLabel',
        defaultMessage: 'No',
        description: 'Label for the "false" option.'
    }
});
